export default __webpack_public_path__ + "static/media/im2.5cb0b335.jpg";